import * as yup from 'yup';
import { getEmailSchema } from 'utils/schema';
import { TLoginFormValues } from './LoginForm.types';
import type { TLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.types';

export const getLoginSchema = (localize: TLocalize) =>
  yup.object<TLoginFormValues>().shape({
    email: getEmailSchema(localize).required(
      localize('validation.email.required') as string
    ),
    password: yup
      .string()
      .required(localize('validation.auth.password.required') as string),
  });
